export default __webpack_public_path__ + "static/media/PPI-walkway-002.b60885a5.jpg";